import * as $ from "jquery";

import imkt from '../../imkt';
import general from '../../utils/general';

imkt.bitbucket = imkt.bitbucket || {};

imkt.bitbucket.CoreJs = function () {
  this.$domRoot = $("body");
  this.$userTierSelect = $("[name^='usersSelectDropdown']", this.$domRoot);
  this.heroPhrases = $(".hero-phrase--animated").map(function (index, phrase) {
    return $(phrase).text();
  });
  this.heroPhraseContainer = $(".hero-phrase--animated:first-child");
  this.heroPhrasesCounter = 1;
  // adg3 test
  imkt.watAdgBB = this;

  this.init();
};

imkt.bitbucket.CoreJs.prototype = {
  init: function () {
    var self = this;
    if ($("body").hasClass("edit")) {
      return;
    }

    if (this.$userTierSelect.length && !this.isMobile()) {
      $.getScript(
        imkt.constants.libPath + "select2.js" + imkt.constants.cdnVersionQuery
      ).done(function () {
        self.$userTierSelect.each(function () {
          var $el = $(this);
          $el.select2({ minimumResultsForSearch: -1 });
        });
      });
    }
    this.bindEvents();
    this.initPhraseLoop();
  },

  bindEvents: function () {
    this.$userTierSelect.on("change", function () {
      var $this = $(this);
      var optionValue = $(this).val().split(",");
      var userCount = optionValue[0];
      var price = optionValue[1];
      var bitbucketRegex = /(\d+|unlimited)(?=_users)/i;

      $this
        .parents(".pricing-column")
        .find(".monthlyPricing")
        .text(general.numberWithCommas(price));

      if ($(".pricing-column.cloud").is(":visible")) {
        var button = $this.parents(".pricing-column.cloud").find("a.button");
        button.attr(
          "href",
          button.attr("href").replace(bitbucketRegex, userCount)
        );
      }
    });

    // adg3 test
    $(".feature-roll-over").on("mouseenter", function () {
      var imageClass = $(this).data("custom");
      $(".feature-roll-over--image, .feature-roll-over").removeClass("active");
      $("." + imageClass).addClass("active");
      $(this).addClass("active");
    });
    // end adg3 test
  },

  initPhraseLoop: function () {
    setInterval(this.initPhraseTransition.bind(this), 5000);
  },

  swapPhrase: function () {
    var currentPhrase = this.heroPhrases[this.heroPhrasesCounter];
    this.heroPhraseContainer.text(currentPhrase);
    this.heroPhraseContainer.fadeIn(500);
    if (this.heroPhrasesCounter < this.heroPhrases.length - 1) {
      this.heroPhrasesCounter++;
    } else {
      this.heroPhrasesCounter = 0;
    }
  },

  initPhraseTransition: function () {
    this.heroPhraseContainer.fadeOut(500, this.swapPhrase.bind(this));
  },

  isMobile: function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
};

// on document ready
$(function () {
  new imkt.bitbucket.CoreJs();
});
